<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body">
            <!-- Filter -->
            <div class="kt-form kt-form--label-right">
                <div class="row align-items-center">
                    <div class="col-xl-12 order-2 order-xl-1">
                        <form class="align-items-center" [formGroup]="form">
                            <div class="row mb-2">
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Currency:</label>
                                </div>
                                <div class="col-md-2 kt-form__control">
                                    <select formControlName="currency_code" class="form-control">
                                        <option value="">All</option>
                                        <option [value]="currency" *ngFor="let currency of currencies">{{ currency }}</option>
                                    </select>
                                </div>
                                <div class="col-md-1 kt-form__label col-form-label">
                                    <label>Date/Time:</label>
                                </div>
                                <div class="col-md-5 kt-form__control">
                                      <div class="input-group date">
                                          <div class="input-group-prepend">
                                              <select formControlName="date_type" class="form-control">
                                                  <option [value]="item.key" *ngFor="let item of dateTimeFilterType">{{ item.label }}</option>
                                              </select>
                                          </div>
                                          <input type="text" class="form-control" placeholder="Search" (change)="onDateRange($event)" formControlName="defaultDate" [timePicker]="true" [timePickerSeconds]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [showCustomRangeLabel]="true" [locale]="dateTimePickerLocale" [timePicker24Hour]="true" [showDropdowns]="true" (click)="updateDateRange()" ngxDaterangepickerMd />
                                          <span class="input-group-append">
                                              <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
                                          </span>
                                      </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="kt-section col-12 row mt-3 mb-3 d-flex justify-content-between">
                <div class="dropdown dropdown-inline">
                    <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
                    <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
                </div>
                <button *ngIf="canCreateReconciliationJob" class="btn btn-brand btn-icon-sm" (click)="onOpenDialog()"><i class="fas fa-plus"></i>Create Reconciliation Job</button>
            </div>
            <div class="kt-section">
                <div class="kt-section__content">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Payment Gateway Account</th>
                                    <th class="text-center">Currency</th>
                                    <th class="text-center">Stage</th>
                                    <th class="text-center">Status</th>
                                    <th>Last Run</th>
                                    <th class="text-center">Reconciliation Status</th>
                                    <th class="text-center">TAC</th>
                                    <th class="date-column">Created By</th>
                                    <th class="date-column">Updated By</th>
                                    <!-- <th class="text-center">Actions</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of paymentGatewayBot$ | async; let i = index">
                                    <td>{{ row.id }} </td>
                                    <td>{{ row.payment_gateway_code }} - {{ row.username }}</td>
                                    <td class="text-center">{{ row.currency_code }}</td>
                                    <td class="text-center">
                                        <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide bot-stage " [ngClass]="'bot-stage-' + row.stage_name"> {{ row.stage_name }}</span>
                                    </td>
                                    <td class="text-center">
                                        <div class="btn-group dropdown">
                                            <button type="button" class="btn btn-pill btn-sm dropdown-base" [ngClass]="'kt-badge--' + (row.switch === 2 ? '11' : row.switch)"> {{ statuses[row.switch] }} </button>
                                            <ng-container *ngIf="canUpdateBankBotStatus">
                                              <button type="button" class="btn btn-pill btn-sm dropdown-toggle" [ngClass]="'kt-badge--' + (row.switch === 2 ? '11' : row.switch)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                  <i class="fa fa-angle-down"></i>
                                              </button>
                                              <div class="dropdown-menu">
                                                  <ng-container *ngFor="let status of statuses; let key = index">
                                                      <button class="dropdown-item" (click)="updateSwitch(row, key)" type="button">{{ statuses[key] }}</button>
                                                  </ng-container>
                                              </div>
                                            </ng-container>
                                        </div>
                                    </td>
                                    <td>{{ row.last_run | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}</td>
                                    <td class="text-center">
                                        <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide recon-status " [ngClass]="'recon-status--' + row.reconciliation_status"> {{ row.reconciliation_status_name }}</span>
                                    </td>
                                    <td class="text-center">
                                        <ng-container *ngIf="row.key">
                                            {{ getTAC(row.key, i) }}
                                            <p *ngIf="row.tac_code && !data['pg-'+i]">{{ row.tac_code }}</p>
                                            <p *ngIf="data && data['pg-'+i]">{{ data['pg-'+i] }}</p>
                                        </ng-container>
                                    </td>
                                    <td>
                                        System<br/>
                                        <span placement="bottom" [ngbTooltip]="createdDateTime" container="body" class="text-ellipsis">{{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</span>
                                        <ng-template #createdDateTime>
                                            {{ row.created_at  | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
                                        </ng-template>
                                    </td>
                                    <td>
                                        System<br/>
                                        <span placement="bottom" [ngbTooltip]="updatedDateTime" container="body" class="text-ellipsis">{{ row.updated_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</span>
                                        <ng-template #updatedDateTime>
                                            {{ row.updated_at  | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
                                        </ng-template>
                                    </td>
                                    <!-- <td class="text-center">
                                        <button *ngIf="canEnterTAC" type="button" class="btn btn-primary btn-sm" [disabled]="row.tac != 1" (click)="updateTAC(row.id)">Enter TAC</button>
                                    </td> -->
                                </tr>
                            </tbody>
                            <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
                        </table>
                    </div>
                    <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
                        <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize" [directionLinks]="true" [boundaryLinks]="true" [rotate]="true" [collectionSize]="pagination.total" (pageChange)="onViewPageBy(page)">
                        </ngb-pagination>
                        <div class="kt-pagination__toolbar">
                            <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
                                <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
                            </select>
                            <span class="pagination__desc">
                                Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<kt-swal-alert [message]="messages$ | async" (confirmed)="reload()"></kt-swal-alert>
